import React from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit"; 
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { CentreData } from "types/models/support/SupportApp";
interface OrderActionsProps {
  data: CentreData;
}
const OrderActions: React.FC<OrderActionsProps> = ({ data }) =>{
     const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/support/supportCentre/CentreCreate/${data.sNo}`);
   
  };
  return (
    <Box>
      <IconButton onClick={handleEdit}>
        <EditIcon style={{ fontSize: 24 }} />
      </IconButton>
    </Box>
  );
};

export default OrderActions;
